import React, { useState } from 'react';
import { SalesDonut } from '../../../components/SalesDonut/SalesDonut';
import classnames from 'classnames';
import { Icon } from '../../../components/Icon/Icon';
import { readBytesUrl } from '../../../util/util';
import { AvatarUpload } from '../../../components/AvatarUpload/AvatarUpload';
import { usePolling } from '../../../model/data';
import { t } from '../../../locales/translate';
import { getTourSalesStats, Tour, patchTour, deleteTour } from '../../../model/tour';
import { Card } from '../../../components/Card/Card';
import { KeyValueTable } from '../../../components/KeyValueTable/KeyValueTable';
import { useConfirmation } from '../../../components/ConfirmationPrompt/ConfirmationPrompt';
import { toursPath } from '../../../routes';
import { history } from '../../../model/history';

export const TourGeneralInfo = ({ tour }: { tour: Tour }): JSX.Element => {
  const [avatarUploadLoading, setAvatarUploadLoading] = useState(false);
  const [avatarUploadError, setAvatarUploadError] = useState(false);
  const [pollingStatus, setPollingStatus] = usePolling(() => {
    getTourSalesStats(tour.id);
  }, 4000);

  async function handleOnChange(e?: File): Promise<void> {
    setAvatarUploadLoading(true);
    try {
      if (!e) {
        await patchTour(tour.id, {
          ticketImage: null,
        });
      } else {
        const bytes = await readBytesUrl(e);
        await patchTour(tour.id, {
          ticketImage: bytes,
        });
      }
      setAvatarUploadLoading(false);
    } catch (e) {
      setAvatarUploadError(true);
      setAvatarUploadLoading(false);
    }
  }

  const { confirm } = useConfirmation({
    message: t.general.confirmDelete(t.model.tour._name),
    action: async () => {
      await deleteTour(tour.id);
      history.push(toursPath());
    },
  });

  return (
    <div className="tour-details__general-info">
      <Card
        elevation={1}
        actions={
          <>
            <Icon
              name="refresh"
              className={classnames('tour-details__live-data', {
                'live-data--active': pollingStatus,
              })}
              onClick={() => setPollingStatus()}
            ></Icon>
            {tour.$permissions.includes('destroy') && <Icon name="trash" onClick={confirm} />}
          </>
        }
        footer=" "
      >
        <div className="tour-details__wrapper">
          <div className="tour-details__avatar">
            <AvatarUpload
              onChange={handleOnChange}
              image={tour && tour.ticketImage && tour.ticketImage.url}
              loading={avatarUploadLoading}
              error={avatarUploadError}
            />
          </div>
          <div className="tour-details__details">
            <h1 className="tour-details__name">{tour.name}</h1>
            <KeyValueTable
              items={[
                {
                  key: t.actions.display(t.general.title),
                  value: tour.internalName,
                },
                {
                  key: t.actions.display(t.general.subtitle),
                  value: tour.subtitle,
                },
              ]}
            />
          </div>
        </div>
        <div className="tour-details__graph">
          {tour.salesStats && <SalesDonut legendType="aside" data={tour.salesStats} size="medium" />}
          {tour.salesStats?.returned !== undefined && (
            <div className="event-status__returned">
              <p>{t.model.sale.returned(tour.salesStats.returned || 0)}</p>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};
